import { useFormat } from './useFormat';

export const useCurrencyFormat = ({
  maximumFractionDigits = 2,
  minimumFractionDigits = 0,
  empty = '-',
  currency = 'USD',
  signDisplay = 'auto',
  notation = 'standard',
  compactDisplay = 'long',
} = {}) => {
  return useFormat({
    type: 'currency',
    maximumFractionDigits,
    minimumFractionDigits,
    empty,
    currency,
    signDisplay,
    notation,
    compactDisplay,
  });
};
